<template>
    <div class="col-md-10 ml-auto mr-auto">
		<form action="">
			<div class="row">
				<div class="col-md-12">
					<div class="form-group">
						<select class="form-control" v-model="selectedSytem" required>
							<option v-bind:value="null" selected>Choisissez un outil</option>
							<option v-for="system in systems" v-bind:value="system" v-bind:key="system.id">
								{{system.name}} - Code : {{system.code}}
							</option>
						</select>
					</div>
				</div>
			</div>
			<div class="text-right mrg-top-5">
				<button type="button" class="btn btn-primary" v-bind:disabled="selectedSytem == null" v-on:click="next">Suivant</button>
			</div>
		</form>
    </div>
</template>

<script>

import { mapGetters } from 'vuex';

export default {
	name: 'CalendarSelect',
	data: () => ({
		selectedSytem: null,
	}),
    props :{
        selected_system_id: {
            type: Number,
            required: false
        },
        action : ""
    },
	mounted() {
		this.$store.dispatch('systems/getSystems');
	},
	watch: {
		systems() {
			for (var i=0; i<this.systems.length; i++){
				if (this.systems[i].id == this.selected_system_id){
					this.selectedSytem = this.systems[i];
				}
			}
		}
	},
	computed: {
		...mapGetters({
			systems: 'systems/systems'
		}),
	},
	methods : {
		next() {
            this.$emit('Choisir-System-done',this.selectedSytem); 
		}
	}
}
</script>
